/* eslint-disable max-classes-per-file */
import { ToJsonInputTranslatable } from '@src/app/model/to-json-input-translatable';
import {
  ItemPriceStockInput,
  StockStatus,
  ValueItemPriceStockInputInputMap,
  ValueItemPriceStockInputInputPair,
} from '@src/app/generated/globalTypes';
import {
  GetAllRetailers_allRetailers_edges_node_priceStocks_edges_node_data,
  GetAllRetailers_allRetailers_edges_node_priceStocks_edges_node_data_ItemPriceStock,
  GetAllRetailers_allRetailers_edges_node_priceStocks_edges_node_data_WoodPriceStock,
} from '@src/app/generated/GetAllRetailers';
import { WoodType } from '@ess/jg-rule-executor';

export class PriceStockData {
  static fromGql(gql: GetAllRetailers_allRetailers_edges_node_priceStocks_edges_node_data): PriceStockData {
    switch (gql.__typename) {
      case 'ItemPriceStock':
        return ItemPriceStock.fromGql(gql);
      case 'WoodPriceStock':
        return WoodPriceStock.fromGql(gql);
      default:
        return undefined;
    }
  }
}

export class ItemPriceStock extends PriceStockData implements ToJsonInputTranslatable {
  stock: StockStatus;
  price: number;
  EAN: string;
  internalCode: string;
  purchasePrice: number;
  discountPrice: number;

  constructor(
    stock?: StockStatus,
    price?: number,
    EAN?: string,
    internalCode?: string,
    purchasePrice?: number,
    discountPrice?: number
  ) {
    super();
    this.stock = stock;
    this.price = price;
    this.EAN = EAN;
    this.internalCode = internalCode;
    this.purchasePrice = purchasePrice;
    this.discountPrice = discountPrice;
  }

  static fromGql(
    gql: GetAllRetailers_allRetailers_edges_node_priceStocks_edges_node_data_ItemPriceStock
  ): ItemPriceStock {
    return new ItemPriceStock(
      gql.stock,
      gql.price,
      gql.EAN,
      gql.internalCode,
      gql.purchasePrice,
      gql.discountPrice
    );
  }

  toGqlInput(): ItemPriceStockInput {
    return {
      stock: this.stock ?? StockStatus.NotAvailable,
      price: this.price ?? 0,
      EAN: this.EAN ?? null,
      internalCode: this.internalCode ?? null,
      purchasePrice: this.purchasePrice ?? null,
      discountPrice: this.discountPrice ?? null,
    };
  }

  static defaultValue = new ItemPriceStock(
    StockStatus.Available,
    0.0,
    'optional EAN',
    'optional internal code'
  );
}

export class WoodPriceStock extends PriceStockData implements ToJsonInputTranslatable {
  prices: Map<WoodType, ItemPriceStock>;

  constructor(prices: Map<WoodType, ItemPriceStock>) {
    super();
    this.prices = prices;
  }

  static fromGql(
    gql: GetAllRetailers_allRetailers_edges_node_priceStocks_edges_node_data_WoodPriceStock
  ): WoodPriceStock {
    const prices: Map<WoodType, ItemPriceStock> = new Map<WoodType, ItemPriceStock>();
    gql.prices.values.map(v => prices.set(v.key, ItemPriceStock.fromGql(v.value)));
    return new WoodPriceStock(prices);
  }

  toGqlInput(): ValueItemPriceStockInputInputMap {
    const valuePairs: ValueItemPriceStockInputInputPair[] = [];
    this.prices.forEach((value, key) => {
      valuePairs.push({ key, value });
    });
    return {
      values: valuePairs,
    };
  }

  static defaultValue = new WoodPriceStock(
    new Map([
      [WoodType.grenen, ItemPriceStock.defaultValue],
      [WoodType.douglas, ItemPriceStock.defaultValue],
    ])
  );
}
